// STYLES
import "../../styles/Components/faq/faqPublic.css";
import styles from "../../styles/Components/faq/AlertSystemGuide.module.css";

// IMAGES
import alert1 from "../../asset/Images/faq/Alert System/1.PNG";
import alert1_2 from "../../asset/Images/faq/Alert System/1-2.PNG";
import alert1_3 from "../../asset/Images/faq/Alert System/1-3.PNG";
import alert1_4_1 from "../../asset/Images/faq/Alert System/1-4-1.png";
import { BiChevronLeft } from "react-icons/bi";
import { useNavigate } from "react-router";
import { LazyLoadImage } from "react-lazy-load-image-component";
import React from "react";
import {
  MdOutlineNotificationsActive,
  MdOutlineTune,
  MdOutlineRepeat,
  MdOutlineSchedule,
  MdOutlineDone,
} from "react-icons/md";
import { FaChartLine } from "react-icons/fa6";

const AlertSystemGuide = function () {
  const navigate = useNavigate();
  return (
    <div className={styles.helpWrapper}>
      <div className={styles.backBtn} onClick={() => navigate("/faq/all")}>
        <BiChevronLeft />
        <span>Back to Help Center</span>
      </div>

      <div className={`${styles.heroCard} ${styles.heroAlert}`}>
        <div className={`${styles.heroIcon} ${styles.heroIconAlert}`}>
          <MdOutlineNotificationsActive />
        </div>
        <div className={styles.heroContent}>
          {/* <div className={styles.heroEyebrow}>
            <MdOutlineNotificationsActive />
            Alert System
          </div> */}
          <h3 className={styles.heroTitle}>Step By Step Guide</h3>
          <p className={styles.heroDesc}>
            Learn how to configure and customize the alert system to receive
            notifications tailored to your trading preferences.
          </p>
        </div>
      </div>

      <div className={styles.stepContainer}>
        <div className={styles.stepHeader}>
          <div className={`${styles.stepNumWrap} ${styles.stepNumAlert}`}>
            <span className={styles.stepNum}>1</span>
          </div>
          <div className={styles.stepInfo}>
            <h4 className={styles.stepTitle}>Access Alert Configuration</h4>
            <div className={styles.stepTag}>
              <MdOutlineTune />
              Change Defaults
            </div>
          </div>
        </div>
        <div className={styles.subStepWrapper}>
          <div className={styles.subStepContainer}>
            <p className={styles.helpLead}>
              Here is a step-by-step guide on how to use the alert system:
            </p>
            <ul className={styles.helpList}>
              <li>
                You can click the "Change" button on the corresponding card to
                change the default settings for any desired section.
              </li>
            </ul>
            <div className={styles.imageWrap}>
              <LazyLoadImage
                src={alert1}
                alt="alert system"
                effect="blur"
                wrapperClassName="imageContainer"
              />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.stepContainer}>
        <div className={styles.stepHeader}>
          <div className={`${styles.stepNumWrap} ${styles.stepNumAlert}`}>
            <span className={styles.stepNum}>2</span>
          </div>
          <div className={styles.stepInfo}>
            <h4 className={styles.stepTitle}>Customize Your Alert Settings</h4>
            <div className={`${styles.stepTag} ${styles.tagConfig}`}>
              <MdOutlineTune />
              Configuration
            </div>
          </div>
        </div>
        <div className={styles.subStepWrapper}>
          <p className={styles.helpLead}>
            Let's go through the steps to customize your alert settings.:
          </p>

          <div className={styles.subSection}>
            <div className={styles.subSectionBadge}>
              <FaChartLine />
            </div>
            <div className={styles.subStepContainer}>
              <p className={styles.subStepTitle}>
                <span className={styles.stepNumberBadge}>1.</span> Risk Appetite
              </p>
              <ul className={styles.helpList}>
                <li>
                  Choose your preferred risk appetite from the list. You can
                  choose from Very Cautious, Cautious, Balanced, Adventurous, or
                  Very Adventurous.
                </li>
              </ul>
              <div className={styles.imageWrap}>
                <LazyLoadImage
                  src={alert1_2}
                  alt="alert system"
                  effect="blur"
                  wrapperClassName="imageContainer"
                />
              </div>
            </div>
          </div>

          <div className={styles.subSection}>
            <div className={`${styles.subSectionBadge} ${styles.subSectionBadge2}`}>
              <MdOutlineRepeat />
            </div>
            <div className={styles.subStepContainer}>
              <p className={styles.subStepTitle}>
                <span className={styles.stepNumberBadge}>2.</span> Alert
                Frequency
              </p>
              <ul className={styles.helpList}>
                <li>
                  Choose your preferred alert frequency from the bu list. You
                  can choose from every 5 minutes, every 15 minutes, every 30
                  minutes, Every 3 hours, Every 6 hours, Every 12 hours, Daily.
                </li>
              </ul>
              <div className={styles.imageWrap}>
                <LazyLoadImage
                  src={alert1_3}
                  alt="alert system"
                  effect="blur"
                  wrapperClassName="imageContainer"
                />
              </div>
            </div>
          </div>

          <div className={styles.subSection}>
            <div className={`${styles.subSectionBadge} ${styles.subSectionBadge3}`}>
              <MdOutlineSchedule />
            </div>
            <div className={styles.subStepContainer}>
              <p className={styles.subStepTitle}>
                <span className={styles.stepNumberBadge}>3.</span> Alert Time
              </p>
              <ul className={styles.helpList}>
                <li>
                  Specify the start and end time for your desired alert time
                  interval.
                </li>
              </ul>
              <div className={styles.imageWrap}>
                <LazyLoadImage
                  src={alert1_4_1}
                  alt="alert system"
                  effect="blur"
                  wrapperClassName="imageContainer"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.successCard}>
        <div className={styles.successBadge}>
          <MdOutlineDone />
        </div>
        <div>
          <h4 className={styles.successTitle}>All Set!</h4>
          <p className={styles.successText}>
            That's it! You have now successfully customized your alert settings.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AlertSystemGuide;
